import { useQuery } from '@tanstack/react-query';
import DropdownStyled from '@/src/app/components/inputs/StyledInputs/DropdownStyled';
import { useCompanyContext } from '@/src/app/context/CompanyContext';
import { SubcontractCOFormItem } from '@/src/app/Interfaces/Accounting/ACForms.interfaces';
import { JCPhase } from '@/src/app/Interfaces/Accounting/JobsContracts.interface';
import { fetchJCJobPhases } from '@/src/app/services/accounting/JobsContractsService';
import React from 'react';

type PhaseCodeProps = {
  item: SubcontractCOFormItem;
  job: string;
  updateItems?: (item: SubcontractCOFormItem) => void;
  fetchData: boolean;
  textMode?: boolean;
  showError?: boolean;
  disabled?: boolean;
};

const PhaseCode = ({
  item,
  job,
  updateItems,
  fetchData,
  textMode = false,
  showError,
  disabled,
}: PhaseCodeProps) => {
  const { selectedCompany } = useCompanyContext();
  const hasError = showError && !item.phase;

  const phasesRequest = useQuery({
    queryKey: ['getJCJobPhases', selectedCompany, job],
    queryFn: ({ signal }) => {
      return fetchJCJobPhases(
        {
          companyID: selectedCompany!.id,
          job,
          hasCost: false,
          costTypes: [3],
        },
        signal
      );
    },
    refetchOnWindowFocus: false,
    enabled: !!(selectedCompany && fetchData),
  });

  const phase = phasesRequest.data?.find(
    (phase: JCPhase) => phase.Phase === item.phase
  );

  return (
    <React.Fragment>
      {!textMode && (
        <DropdownStyled
          value={item.phase}
          options={phasesRequest.data?.map((phase: JCPhase) => ({
            label: `${phase.Phase} - ${phase.Description}`,
            ...phase,
          }))}
          labelField="label"
          valueField="Phase"
          placeholder={
            phasesRequest.isError
              ? 'Failed to load phase codes!'
              : 'Select Phase Code'
          }
          isDisabled={phasesRequest.isError}
          isLoading={phasesRequest.isFetching}
          clearable={true}
          filter={true}
          resetFilterOnHide={true}
          disabled={!item.isNew || disabled}
          onChange={(e) => {
            item.phase = e.value;
            if (updateItems) updateItems(item);
          }}
          className={`${hasError && 'p-invalid'} printHide`}
        />
      )}
      <span className={textMode ? undefined : `printMedia printShow`}>
        {phase?.Phase} - {phase?.Description}
      </span>
    </React.Fragment>
  );
};

export default PhaseCode;
